import { render, staticRenderFns } from "./CollapsibleMenuComponent.vue?vue&type=template&id=7a37f0ba"
import script from "./CollapsibleMenuComponent.vue?vue&type=script&lang=js"
export * from "./CollapsibleMenuComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports